<div fxLayout="row" fxLayoutAlign="center start">
  <div class="container">
    <app-header-component></app-header-component>
    <app-info-squares></app-info-squares>
    <app-commuting-calculate id="calculator"></app-commuting-calculate>
    <app-info-stats></app-info-stats>
    <app-footer></app-footer>
  </div>
</div>
